import { Component, OnInit } from '@angular/core';
import { headerConfig } from '../../../header-config';
import { OktaAuthService } from '@okta/okta-angular';
import { ConfigService } from 'src/app/config.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  menu: any[];
  userInfo: {};

  constructor(
    public oktaAuth: OktaAuthService,
    public config: ConfigService
  ) {

  }

  async ngOnInit() {
    this.menu = headerConfig.menu;
    // returns an object with user's claims
    this.oktaAuth.$authenticationState.subscribe(
      async (isAuthenticated: boolean) => {
        /* istanbul ignore next */
        if (isAuthenticated) {
          const userClaims = await this.oktaAuth.getUser();
          // user name is exposed directly as property
          this.userInfo = {
            username : userClaims.name || ''
          };
          this.config.authToken = await this.oktaAuth.getAccessToken();
          // sending user-data to pendo
          (window as any).pendo.updateOptions({
            visitor: {
              id: userClaims.email,
              email: userClaims.email,
              name: userClaims.name,
            },
            account: {
              id: userClaims.email,
            },
          });
        }
      }
    );
  }
}
